import { render, staticRenderFns } from "./VerticalTimeline.vue?vue&type=template&id=56c37446&scoped=true&"
import script from "./VerticalTimeline.vue?vue&type=script&lang=js&"
export * from "./VerticalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTimeline.vue?vue&type=style&index=0&id=56c37446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c37446",
  null
  
)

export default component.exports